export default "__VITE_ASSET__40ab8a1c__"